export const popoverTokens = {
  gutter: '10px',
  arrowOffset: '1.125rem',
} as const;
